import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FabricService} from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'mgmt-local-config-resources';
export const RELEASE_VERSION_THRESHOLD = 202604;


@Injectable({
  providedIn: 'root'
})
export class LocalConfiguration {

  constructor(private fabricService: FabricService) {}

  putLocalConfigApply(id: string, localConfigurationId: String): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_instances_id_local-configurations_apply',   
    { id, localConfigurationId } );
  }

  getLocalConfig(id: String, localConfigurationId: String): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_local-configurations_localconfigurationid', {id, localConfigurationId});
  }

  getLocalConfigResult(id: String, localConfigurationId: String): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_local-configurations_results', { id, localConfigurationId});
  }

  getLocalConfigResultId(id: string, resultId: string): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_local-configurations_results_resultid', { id, resultId });
  }

  getLocalConfigurations(id: String): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_local-configurations', {id});
  }

  getLocalConfigurationInit(id: String): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_local-configuration-init', {id});
  }

  putLocalConfigurationInit(id: String): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_instances_id_local-configuration-init', {id});
  }

}